import type {
  WebhooksWebhookResponse,
  WebhooksEventTypeDto,
  WebhooksWebhookRequest,
  WebhooksTestEventRequest,
} from '@shipium-corp/shipium-ts-types';
import { arrayToMap } from '~/hooks/useQueryCreator';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import { addOrUpdateQueryRecordData, removeFromQueryRecordData } from '../api-utils';

export const webhooksMaintenance = {
  search: {
    queryKey: 'partner-webhooks-service/webhooks',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<WebhooksWebhookResponse[]>(
        '/partner-webhooks-proxy/api/v1/partner-webhooks/webhooks',
      );

      return arrayToMap(data, 'webhookId');
    },
  },
  eventTypes: {
    queryKey: 'partner-webhooks-service/webhooks/event-types',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<WebhooksEventTypeDto[]>(
        '/partner-webhooks-proxy/api/v1/partner-webhooks/event-types',
      );

      return data;
    },
  },
  create: async (payload: WebhooksWebhookRequest) => {
    const { data } = await GatewayAxiosClient.post<WebhooksWebhookResponse>(
      '/partner-webhooks-proxy/api/v1/partner-webhooks/webhooks',
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [],
      updateQueryData: [
        {
          queryKey: ['partner-webhooks-service/webhooks'],
          fn: (queryData: Record<string, WebhooksWebhookResponse>) =>
            addOrUpdateQueryRecordData(queryData, data, 'webhookId'),
        },
      ],
    };
  },
  update: async ({ webhookId, payload }: { webhookId: string; payload: WebhooksWebhookRequest }) => {
    const { data } = await GatewayAxiosClient.put<WebhooksWebhookResponse>(
      `/partner-webhooks-proxy/api/v1/partner-webhooks/webhooks/${webhookId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [],
      updateQueryData: [
        {
          queryKey: ['partner-webhooks-service/webhooks'],
          fn: (queryData: Record<string, WebhooksWebhookResponse>) =>
            addOrUpdateQueryRecordData(queryData, data, 'webhookId'),
        },
      ],
    };
  },
  delete: async (webhookId: string) => {
    const { data } = await GatewayAxiosClient.delete(
      `/partner-webhooks-proxy/api/v1/partner-webhooks/webhooks/${webhookId}`,
    );

    return {
      data,
      invalidateQueryKeys: [],
      updateQueryData: [
        {
          queryKey: ['partner-webhooks-service/webhooks'],
          fn: (queryData: Record<string, WebhooksWebhookResponse>) => removeFromQueryRecordData(queryData, webhookId),
        },
      ],
    };
  },
  testEvent: async (payload: WebhooksTestEventRequest) => {
    const { data } = await GatewayAxiosClient.post<void>(
      '/partner-webhooks-proxy/api/v1/partner-webhooks/test-events',
      payload,
    );

    return data;
  },
};
